import * as yup from 'yup';

import { descriptionMaxLength } from '../../../../shared/utils/description-max-length.util';

export const getBasicInfoFormValidationSchema = yup.object().shape({
  name: yup.string().required('Please add a campaign name !'),
  startDate: yup
    .date()
    .nullable()
    .required('Please add a start date !')
    .typeError('Invalid date '),
  endDate: yup
    .date()
    .nullable()
    .required('Please add a end date !')
    .typeError('Invalid date '),
  wifiExpirationDate: yup
    .date()
    .nullable()
    .required('Please add a wifi expiration date !')
    .typeError('Invalid date '),
  maxRetryNo: yup
    .number()
    .integer()
    .min(0)
    .typeError('The entered maximum retry number is invalid.')
    .required('Please add a maximum retry number !'),
  description: yup
    .string()
    .max(descriptionMaxLength, 'Maximum 4000 characters.')
    .required('Please add a full description !'),
  firmwareIds: yup
    .array()
    .test(
      'Firmwares ids test',
      'Please select at least one firmware!',
      value => !!value?.length
    )
    .required(),
  status: yup.object().nullable().required('Please select a status !'),
  version: yup.string().required('Please add a version !'),
});
